import PropTypes from 'prop-types';
// @mui
import { Card, Typography, CardMedia, CardActionArea, CardContent, CardActions, Button } from '@mui/material';
import Iconify from '../../../components/iconify';
import { getSensorObject, getSensorType } from '../../../services/localizationService';

StandardCard.propTypes = {
  standard: PropTypes.object,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  onImageClick: PropTypes.func,
};

export default function StandardCard({ standard, onEdit, onDelete, onImageClick }) {
  const { id, name, sensorType, description, operator, value } = standard;

  const getOperation = (oper) => {
    switch (oper) {
      case 'eq':
        return '=';
      case 'neq':
        return '!=';
      case 'greater':
      case 'gt':
        return '>';
      case 'gte':
        return '>=';
      case 'lesser':
      case 'lt':
        return '<';
      case 'lte':
        return '<=';
      default:
        return 'Unknown';
    }
  };

  const sensorObject = getSensorObject(sensorType);
  const sensorImage = sensorObject.imageLocation;
  const displayString = `${getSensorType(sensorType)} Value ${getOperation(operator)} ${value}`;

  return (
    <Card sx={{ height: 350, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <CardActionArea sx={{ display: 'flex', justifyContent: 'center' }}>
        <CardMedia
          component="img"
          height="140"
          width="140"
          sx={{ width: 140 }}
          image={sensorImage}
          alt="sensor icon"
          onClick={() => {
            onImageClick(standard);
          }}
        />
      </CardActionArea>
      <CardContent sx={{ textAlign: 'center', width: '100%', flexGrow: 1 }}>
        <Typography variant="h6" noWrap>
          {name}
        </Typography>
        <Typography variant="body1">
          {description}
        </Typography>
        <Typography variant="body2">{displayString}</Typography>
      </CardContent>
      <CardActions sx={{ justifyContent: 'center', width: '100%', position: 'absolute', bottom: 16 }}>
        <Button
          size="small"
          color="error"
          startIcon={<Iconify icon="eva:trash-2-outline" />}
          onClick={() => {
            onDelete(standard.id);
          }}
          sx={{ mr: 1 }}
          >
            Delete
          </Button>
          <Button 
          size="small" 
          color="primary"
          startIcon={<Iconify icon="eva:edit-fill" />}
          onClick={() => {
            onEdit(standard);
          }}
        >
          Edit
        </Button>
      </CardActions>
    </Card>
  );
}
